import {RendererApi} from "marked";

const fontSizes = {
    heading: "1.125rem",
    subHeading: "1rem",
    text: "1rem",
};

export const renderer: Partial<RendererApi> = {
    heading(text, level) {
        const parsedLevel = level + 1;
        const size = level === 1 ? fontSizes.heading : fontSizes.subHeading;

        return `<h${parsedLevel} style="margin:0;font-size:${size};">${text}</h${parsedLevel}>`;
    },
    paragraph(text) {
        return `<p style="font-size:${fontSizes.text}">${text}</p>`;
    },
    list(body, ordered) {
        const tag = ordered ? "ol" : "ul";

        return `<${tag} style="display:grid;gap:8px;font-size:${fontSizes.text};">${body}</${tag}>`;
    },
    listitem(text) {
        return `<li style="display:list-item">${text}</li>`;
    },
    image() {
        return "";
    },
    link(href, _title, text) {
        return `<a href="${href}">${text}</a>`;
    },
};
